import { render, staticRenderFns } from "./bidInfo.vue?vue&type=template&id=d382aaa0&scoped=true&"
import script from "./bidInfo.vue?vue&type=script&lang=js&"
export * from "./bidInfo.vue?vue&type=script&lang=js&"
import style0 from "./bidInfo.vue?vue&type=style&index=0&id=d382aaa0&prod&lang=scss&scoped=true&"
import style1 from "./bidInfo.vue?vue&type=style&index=1&id=d382aaa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d382aaa0",
  null
  
)

export default component.exports